<svelte:options accessors={true}/>
<script>
	import CellsMenu from './../components/CellsMenu.svelte';
	import Toast from './../components/Toast.svelte';
    import {onMount} from 'svelte';
    import ReportsService from "../services/reports.service";
    import Loader from "../components/Loader.svelte";
    import ColorPicker from "../components/ColorPicker.svelte";
    import EditableCell from "../components/EditableCell.svelte";
    import AuthService from '../services/auth.service.js';
    import { formatValue } from '../helpers/format.helper';
    import { stylesList, getPastDateData } from '../helpers/style.helper';
    import ExportService from "../services/export.service";

    let sections, kpiToChange, errorMessage, disableButton = false, disableSaveButton = false, dropped = [],
        dropped_in = '', sectionName = '', loading = false, deleteConfirmation = false, deletedItems = [], currentKPI = {},
        currentSection = {}, sectionToChange = {}, selectedSection = null,  headers = [], sectionDragged, kpiDragged, formulas,
        aditionSections, sectionsStates = {};

    export let user, params, loadingExport = false;

    $: loadData(params);

    export async function loadData() {
        if (loading) return;
        loading = true;
        selectedSection = null;
        var e = jQuery.Event("blur", {keyCode: 27, key: 27});
        jQuery(".cellPasted").trigger(e);

        sections = null;
        const url = '/org/' + params.org + '/sdr/date/' + params.year;
        let result = null;

        try {
            result = await ReportsService.load(url);

            //Scroll to previous position
            setTimeout(() => {
                var scrolled = (localStorage.getItem('scrolled'))? localStorage.getItem('scrolled') : 0;
                jQuery('#reportsDiv').scrollTop(scrolled);
                localStorage.setItem("scrolled",0);
            }, 500);
        } catch (e) {
            sections = null;
            console.error('Error loading data!');
        }

        if (result && result.data){
            sections = result.data.sections;
            headers = result.data.headers;
            formulas = result.data.formulas;
            aditionSections = formulas.reduce(function (acc, formula) {
                if (formula.type === 'adition') acc.push(formula.section);
                return acc;
            }, []);
        }
        loading = false;

        setTimeout(() => {
            jQuery('.sticky-thead').removeClass('d-none');
            tablesLoaded();
            enableTableSelection();
        }, 700);
    }

    onMount( () => {
        let sectionsJSON = localStorage.getItem('sections-toggle');
        sectionsStates = sectionsJSON? JSON.parse(sectionsJSON) : {};
        cleanKPI();
        loadData();
    });

    let saveKPIData = async function(kpi_id, date, actual, kpi, section, elementId) {
        const isAditionSection = aditionSections.includes(section.sdr_section);
        if(kpi.sdr_kpi != null || isAditionSection) updateCalculatedKpi(kpi.sdr_kpi, section.sdr_section, date, isAditionSection);
        date = params.year + '-' + date + "-01";
        let body = { kpi_id, date, actual, locked: false, notes: 'none' };
        await ReportsService.saveKpiData(body);
        jQuery('#'+elementId).addClass('manual-data-kpi')
    }

    let updateCalculatedKpi = function(kpi, section, date, specificSection = false, formula = null){
        if(specificSection){
            // Adition
            formula = formulas.filter( formula => formula.section == section)[0];
        }
        if(!formula){
            const affectedFormulas = formulas.filter( formula => formula.section == section && formula.kpis && formula.kpis.includes(kpi));
            // In case this kpi change affect to multiple formulas
            if(affectedFormulas.length > 1){
                affectedFormulas.map(formula => {
                    updateCalculatedKpi(null, null, date, null, formula);
                });
                return false; // Exit
            }else{
                formula = affectedFormulas[0];
            }
        }
        if(formula){
            let section = sections.filter( (section) => section.sdr_section == formula.section)[0];
            const kpiIndexes = (formula.kpis) ? formula.kpis.split(",").map(Number) : [null];
            let kpisData = section.kpis.filter( kpi => kpiIndexes.includes(kpi.sdr_kpi));
            let value = 0;
            if(specificSection){
                kpisData = kpisData.filter(kpi => !kpi.sdr_formula); // Avoid tu use calculated kpis in formulas
            }
            switch (formula.type) {
                case 'multiplication':
                    value = 1;
                    kpisData.map(kpiData => {
                        value *= parseFloat(kpiData.kpiData[date].actual);
                    });
                    break;
                case 'division':
                    if(kpisData[1].kpiData[date].actual != 0){
                        value = kpisData[0].kpiData[date].actual / kpisData[1].kpiData[date].actual;
                        value *= 100;
                    }
                    break;
                case 'subtraction':
                    value = kpisData[0].kpiData[date].actual - kpisData[1].kpiData[date].actual;
                    break;
                case 'adition':
                    kpisData.map(kpiData => {
                        value += parseFloat(kpiData.kpiData[date].actual);
                    });
                    break;
            }
            asignResult(formula.id, value, date);
        }
    }

    let asignResult = function(formulaId, value, date){
        const kpiSection = sections.filter( section => getCalculatedKpi(section, formulaId))[0];
        const calculatedKpi = kpiSection.kpis.filter ( kpi => kpi.sdr_formula == formulaId)[0];
        calculatedKpi.kpiData[date].actual = value;
        // Check if this result will afect another calculation
        const anotherCalculation = formulas.filter(formula => formula.section == kpiSection.sdr_section && formula.kpis && formula.kpis.includes(calculatedKpi.sdr_kpi));
        if(anotherCalculation.length > 0){
            anotherCalculation.map(formula => {
                updateCalculatedKpi(null, null, date, null, formula);
            });
        }
    }

    function getCalculatedKpi(section, formulaId) {
        let kpi = section.kpis.filter(kpi => kpi.sdr_formula == formulaId);
        return (kpi.length == 0)? false : true;
    }

    let onSaveKPI = async function() {
        disableSaveButton = true;
        errorMessage = null;

        try {
            if (currentKPI.id) {
                if(JSON.stringify(currentKPI) != JSON.stringify(kpiToChange)){
                    await ReportsService.updateKpi(currentKPI);
                    loadData();
                }
            } else {
                await ReportsService.saveKpi(currentKPI);
                loadData();
            }

            disableSaveButton = false;
            jQuery('#addKPI').modal('hide');
            cleanKPI();
        } catch (e) {
            errorMessage = e.message;
        }
    };

    let onSaveSection = async function() {
        disableSaveButton = true;
        errorMessage = null;
        let response = null;

        try {
            if(currentSection.id){
                if(JSON.stringify(sectionToChange) != JSON.stringify(currentSection)){
                    await ReportsService.updateSection(currentSection);
                    loadData();
                }
            }else{
                await ReportsService.saveSection(currentSection);
                loadData();
            }
            disableSaveButton = false;
            jQuery('#editSection').modal('hide');
            currentSection = {}; //"Clean" it
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let onDeleteKPI = async function() {
        errorMessage = null;
        disableButton = true;

        try {
            await ReportsService.deleteKpi(currentKPI.id);
            deleteConfirmation = false;
            jQuery('#addKPI').modal('hide');
            cleanKPI();
            loadData();
        } catch (e) {
            errorMessage = e.message;
        }
    }

    let setDeleteConfirmation = function (){
        deleteConfirmation = true;
        setTimeout(() => {
            if (deleteConfirmation) deleteConfirmation = false;
        }, 3000);
    }

    function cleanKPI() {
        currentKPI = {
            type: '2', // SDR
            title: '',
            taxonomy: '',
            format: 0,
            section_id: null,
            notes: '',
            taxonomy_notes: '',
            locked: 0,
            style: ''
        };
    }

    function fillKPI(section) {
        jQuery('#kpi-tab').click();
        cleanKPI();
        currentKPI.section_id = section.id;
        sectionName = section.title;
        jQuery('#addKPI').modal('show');
    }

    function editKPI(e, kpi) {
        deleteConfirmation = false;
        disableButton = false;
        jQuery('#kpi-tab').click();
        currentKPI = kpi;
        kpiToChange = { ...currentKPI };
        jQuery('#addKPI').modal('show');
    }

    function switchKPILock() {
        currentKPI.locked = currentKPI.locked === 1? 0: 1;
    }

    let showUnlockTooltip = function() {
        jQuery('#btnLock').tooltip('show');
        setTimeout(() => {
            jQuery('#btnLock').tooltip('hide');
        }, 5000);
    };

    async function handleDrop(e, section_id, position) {
        e.preventDefault();

        // remove borders styles
        e.target.style.borderTop = '';
        e.target.style.borderBottom = '';

        let id = e.dataTransfer.getData('text');

        // Add element below the target
        if (!ReportsService.isElementTopPosition(e)) position++;

        try {
            await ReportsService.updateKpiPosition({id, type: 2, section_id, position});
            loadData();
        } catch (e) {
            console.log(e);
        }
    }

    function handleDragStart(e, id, sectionId) {
        sectionDragged = sectionId;
        kpiDragged = id;
        e.dataTransfer.dropEffect = 'move';
        e.dataTransfer.setData("text", id);
    }

    function handleDragEnter(e) {
        e.dataTransfer.dropEffect = 'move';
        window.jQuery(e.target).css('border-top', '2px dashed #fdc59b');
        window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
    }

    function handleDragLeave(e) {
        window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        window.jQuery(e.target).css('border-bottom', '1px solid #dee2e6');
        window.jQuery(e.target).css('box-shadow', 'none');
    }

    /**
     * Handle the drag over event to show the drop effect
     */
     function handleDragOver(e) {
        e.dataTransfer.dropEffect = 'move';

        if (ReportsService.isElementTopPosition(e)) {
            window.jQuery(e.target).css('border-top', '3px dashed #fdc59b');
            window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
            window.jQuery(e.target).css('border-bottom', '1px solid #dee2e6');
        } else {
            window.jQuery(e.target).css('border-bottom', '3px dashed #fdc59b');
            window.jQuery(e.target).css('box-shadow', 'inset 0 0 10px #fdc59b');
            window.jQuery(e.target).css('border-top', '1px solid #dee2e6');
        }
        e.preventDefault();
    }

    function toggleSection(section) {
        sectionsStates[section.id] = !sectionsStates[section.id];
        localStorage.setItem('sections-toggle', JSON.stringify(sectionsStates));
        setTimeout(() => {
            enableTableSelection();
        }, 250);
    }

    function editSection(section) {
        currentSection = section;
        deleteConfirmation = false;
        disableButton = false;
        sectionToChange = { ...currentSection }; //Used to verify if at least a field change
        jQuery('#editSection').modal('show');
    }

    async function changeSectionPosition(sectionId, newPosition){
        if(selectedSection != sectionId){
            try {
                await ReportsService.updateSectionPosition({id: selectedSection, position: newPosition});
                loadData();
            } catch (e) {
                console.log(e);
            }
        }
        selectedSection = null;
    }

    function onSelectSection(sectionId){
        selectedSection = sectionId;
        jQuery('.sticky-thead').addClass('d-none');
    }

    function getSdrFormat(code, date, value){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        today = mm + '/' + dd + '/' + yyyy;
        if(yyyy < params.year || (params.year == yyyy && mm <= new Date(Date.parse(date +" 1")).getMonth()+1)) return '';

        let kpi;
        const MONTHLY_LEADS_GOALS_SECTION = sections.find(section => section.sdr_section === 3);
        switch(code) {
            case '1012':
                kpi = MONTHLY_LEADS_GOALS_SECTION.kpis.filter( kpi => kpi.code == 1015);
                break;
            case '1013':
                kpi = MONTHLY_LEADS_GOALS_SECTION.kpis.filter( kpi => kpi.code == 1016);
                break;
        }
        if(kpi){
            if(value < kpi[0].kpiData[date].actual){
                return 'style-red';
            }else{
                return 'style-green';
            }
        }else{
            return '';
        }
    }

    function getDate(date) {
        let months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
        date = date.charAt(0).toUpperCase() + date.slice(1);
        return months.indexOf(date).toString().padStart(2, '0') + '/01/' + params.year;
    }

    export async function exportToExcel() {
        const urlToExport = '/org/' + params.org + '/sdr/date/' + params.year;
        let result = null;
        loadingExport = true;

        try {
            result = await ReportsService.load(urlToExport);
            if (result && result.data){
                await ExportService.downloadSDR(result.data.sections, user.name, 'SDR-' + jQuery('#dropdownOrganizations').text() + "-" + params.year, result.data.headers);
            } else {
                console.log('No sections found');
            }
        } catch (e) {
            console.log('Error', e);
        }

        loadingExport = false;
    }
</script>
<button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>

<div class="modal fade" id="addKPI" tabindex="-1" role="dialog" aria-labelledby="addKPILabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addKPILabel">
                    {#if currentKPI.id}
                        Edit KPI
                        {#if AuthService.can('UNLOCK_KPI') }
                            <button id="btnLock" class="btn btn-sm ml-auto" on:click={switchKPILock} data-toggle="tooltip" data-placement="right" title="Click here to unlock">
                                {#if currentKPI.locked === 1}
                                    <span class="fa fa-lock"></span>
                                {:else}
                                    <span class="fa fa-unlock text-warning"></span>
                                {/if}
                            </button>
                        {/if}
                    {:else}
                        <span class="text-muted">Add New KPI to</span>
                        <em class="text-dark bg-warning px-1">{sectionName}</em>
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="kpi" role="tabpanel" aria-labelledby="kpi-tab">
                            {#if currentKPI.id}
                                <div class="form-group">
                                    <p><b>KPI ID:</b> {currentKPI.id} </p>
                                </div>
                            {/if}
                            <div class="form-group">
                                <label for="nameInput">Title</label>
                                <input bind:value={currentKPI.title} maxlength="64" type="text" class="form-control" id="nameInput" placeholder="Title">
                            </div>
                            <div class="form-group">
                                <label for="taxonmyInput">Taxonomy & Definitions</label>
                                <input bind:value={currentKPI.taxonomy} maxlength="128" type="text" class="form-control" id="taxonmyInput" placeholder="Taxonomy and Definitions">
                            </div>
                            <div class="form-group">
                                <label for="commentsInput">Comments</label>
                                <textarea bind:value={currentKPI.comments} type="text" rows="4"
                                    class="form-control" id="commentsInput" placeholder="This will be shown in the last column"></textarea>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {#if errorMessage}
                <div class="alert alert-danger">
                    ERROR: {errorMessage}
                </div>
            {/if}
            <div class="modal-footer">
                {#if AuthService.can('DELETE_KPI') && !currentKPI.locked}
                    {#if currentKPI.id}
                        {#if deleteConfirmation}
                            <button type="button" class="btn btn-danger mr-auto" on:click={onDeleteKPI} disabled={disableButton}>
                                Click to confirm
                            </button>
                        {:else}
                            <button type="button" class="btn btn-danger mr-auto" on:click={setDeleteConfirmation}>
                                DELETE
                            </button>
                        {/if}
                    {/if}
                {/if}

                <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanKPI}>Close</button>

                <button type="button" class="btn btn-success" on:click={onSaveKPI} disabled={disableSaveButton}>
                    {#if currentKPI.id}
                        Update
                    {:else}
                        Save
                    {/if}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editSection" tabindex="-1" role="dialog" aria-labelledby="editSection" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editSectionLabel">
                    Edit
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {#if AuthService.can('EDIT_TEAM') }
                    <label for="teamName">Name:</label>
                    <input bind:value={currentSection.title} maxlength="64" type="text" class="form-control" id="sectionName" placeholder="Section Name">
                    {#if !currentSection.title}
                        <small class="text-danger ml-2 font-weight-bold">Name is required</small>
                    {/if}
                {/if}
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                {#if currentSection.title}
                    <button type="button" class="btn btn-success " on:click={onSaveSection} disabled={disableSaveButton}>
                        Update
                    </button>
                {:else}
                    <button type="button" class="btn btn-danger disabled" disabled={disableSaveButton}>
                        Update
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader fixed={true}></Loader>
{/if}

{#if !sections}
    <h4 class="text-danger text-center">...</h4>
{:else}
    <div id="popover-notes" class="comment-popover d-none" ></div>
    <div id="popover-comments" class="comment-popover d-none" >
        <div id="close-comments" class="text-right text-primary pointer h6 font-weight-bold">X</div>
        <div id="comments-body"></div>
    </div>
    {#each sections as section, sectionIndex}
        {#if section.position !== null}
            {#if selectedSection}
                <div class="move-here"
                    on:click={ changeSectionPosition(section.id, section.position) }>
                    Click here to move it
                </div>
            {/if}
            <div class="table-wrapper { selectedSection && selectedSection == section.id ? 'selectedSection' : ''}">
                <table class="table table-sm container-fluid table-weekly selectable-table { section.sdr_collapse? 'collapsable': 'notcollapsable' }">
                    <thead>
                        <tr class="{section.position !== null? 'bg-dark': 'bg-danger'} text-light ">
                            <th class="{section.position !== null? 'col-header': 'bg-danger'}">
                                {#if section.sdr_collapse === 1}
                                    <i on:click={ () =>  toggleSection(section)}
                                       class="mr-1 fa fa-{ sectionsStates[section.id]? 'minus': 'plus' }-square text-light btn btn-sm px-0"></i>
                                {/if}
                                {section.title}
                                {#if section.position !== null && AuthService.can('EDIT_SECTION') }
                                    <i on:click={ () =>  editSection(section)}
                                        class="fa fa-pencil-square-o text-light float-right btn btn-sm px-0"></i>
                                    {#if !selectedSection}
                                        <i
                                            class="fa fa-arrows pointer mr-1 mt-1 float-right"
                                            on:click={ onSelectSection(section.id)}
                                        ></i>
                                    {/if}
                                {/if}
                            </th>
                            <th class="col-subheader">Taxonomy & Def.</th>
                            {#each headers as id}
                                <th class="notFixed">{id}</th>
                            {/each}
                            <th class="col-comments notFixed">Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each section.kpis as kpi, kpiIndex}
                            <tr>
                                {#if section.sdr_collapse === 0 || sectionsStates[section.id] === true}
                                    <th class="col-header rowDropArea"
                                        draggable="{(section.sdr_editable) ? true : false}"
                                        on:dragstart={(e) => handleDragStart(e, kpi.id, section.id) }
                                        on:dragover={(e) => (sectionDragged === section.id && kpiDragged !== kpi.id? handleDragOver(e): true)}
                                        on:dragleave={(e) => (sectionDragged === section.id && kpiDragged !== kpi.id? handleDragLeave(e): true)}
                                        on:drop={(e) => (sectionDragged === section.id && kpiDragged !== kpi.id? handleDrop(e, section.id, kpiIndex): true) }>
                                        {#if kpi.notes && kpi.notes.length > 0}
                                            <i data-notes="{kpi.notes}"
                                            class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                        {/if}
                                        {#if AuthService.can('EDIT_KPI') }
                                            {#if kpi.locked === 1}
                                                {#if AuthService.can('UNLOCK_KPI') }
                                                    <i data-id="{kpi.id}" on:click={ (e) => editKPI(e, kpi) }
                                                    class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                                {/if}
                                                <span class="fa fa-lock text-warning float-right btn btn-sm px-0 not-allowed"></span>
                                            {:else}
                                                <i data-id="{kpi.id}" on:click={ (e) => editKPI(e, kpi) }
                                                class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                            {/if}
                                        {/if}
                                        {#if section.position === null && kpi.code}<span class="text-danger">{kpi.code}</span>{/if}
                                        {kpi.title}
                                    </th>
                                    <td class="col-subheader">
                                        {#if kpi.taxonomy_notes && kpi.taxonomy_notes.length > 0}
                                            <i data-notes="{kpi.taxonomy_notes}"
                                            class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                        {/if}
                                        {kpi.taxonomy || '' }
                                    </td>
                                    {#if kpi.kpiData }
                                        {#each Object.keys(kpi.kpiData) as id, kpiDataIndex}
                                            {#if AuthService.can('EDIT_CELL') && kpi.sdr_formula == null}
                                                <td class="{ AuthService.can('EDIT_KPI')? 'notFixed': 'readOnly'} ">
                                                    <EditableCell
                                                        customClass="{getSdrFormat(kpi.code, id, kpi.kpiData[id].actual)} {(!kpi.kpiData[id].actual_imported)?'manual-data-kpi':''}"
                                                        id="t{sectionIndex}-{kpiIndex}-{kpiDataIndex}"
                                                        xdata="{ {id: kpi.id, report: 'sdr', date: getDate(id), field: 'actual', value: kpi.kpiData[id].actual } }"
                                                        on:change={(e) => saveKPIData(kpi.id, id, e.detail.value, kpi, section, `t${sectionIndex}-${kpiIndex}-${kpiDataIndex}`)}
                                                        bind:value={kpi.kpiData[id].actual}
                                                        format={kpi.format}></EditableCell>
                                                </td>
                                            {:else}
                                                <td class="notFixed readOnly">
                                                    { formatValue(kpi.format, kpi.kpiData[id].actual) }
                                                </td>
                                            {/if}
                                        {/each}
                                    {:else}
                                        <td class="text-danger">No data</td>
                                    {/if}
                                    <td class="col-comments notFixed readOnly">
                                        <span data-comments="{kpi.comments || ''}" class="text-primary comments-truncate weekly pointer full-comments">
                                            {kpi.comments || ''}
                                        </span>
                                    </td>
                                {:else if kpi.sdr_formula !== null}
                                    <th class="col-header">
                                        {#if kpi.notes && kpi.notes.length > 0}
                                            <i data-notes="{kpi.notes}"
                                            class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                        {/if}
                                        {#if AuthService.can('EDIT_KPI') }
                                            {#if kpi.locked === 1}
                                                {#if AuthService.can('UNLOCK_KPI') }
                                                    <i data-id="{kpi.id}" on:click={ (e) => editKPI(e, kpi) }
                                                    class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                                {/if}
                                                <span class="fa fa-lock text-warning float-right btn btn-sm px-0 not-allowed"></span>
                                            {:else}
                                                <i data-id="{kpi.id}" on:click={ (e) => editKPI(e, kpi) }
                                                class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 ml-1 action-edit"></i>
                                            {/if}
                                            {kpi.title}
                                        {/if}
                                    </th>
                                    <td class="col-subheader">
                                        {#if kpi.taxonomy_notes && kpi.taxonomy_notes.length > 0}
                                            <i data-notes="{kpi.taxonomy_notes}"
                                            class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                        {/if}
                                        {kpi.taxonomy || '' }
                                    </td>
                                    {#if kpi.kpiData }
                                        {#each Object.keys(kpi.kpiData) as id, kpiDataIndex}
                                            <td class="notFixed readOnly">
                                                { formatValue(kpi.format, kpi.kpiData[id].actual) }
                                            </td>
                                        {/each}
                                    {:else}
                                        <td class="text-danger">No data</td>
                                    {/if}
                                    <td class="col-comments notFixed readOnly">
                                        <span data-comments="{kpi.comments || ''}" class="text-primary comments-truncate weekly pointer full-comments">
                                            {kpi.comments || ''}
                                        </span>
                                    </td>
                                {/if}
                            </tr>
                        {/each}
                        <tr class="border-0">
                            <th class="bg-transparent col-header">
                                {#if section.sdr_editable && AuthService.can('ADD_KPI') }
                                    <button class="mt-2 btn btn-primary btn-sm text-light float-left"
                                            data-id="{section.id}"
                                            on:click|preventDefault={(e) => fillKPI(section)}>
                                        <i class="fa fa-plus"></i>
                                        Add KPI
                                    </button>
                                {/if}
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        {/if}
    {/each}

{/if}
<div class="table-sdr-wrapper">
    <table class="table table-sm table-sdr">
        <colgroup>
            <col style="width: 10%;">
            <col style="width: 30%;">
            <col style="width: 60%;">
        </colgroup>
        <thead>
            <tr class="bg-dark text-light">
                <th class="col-header">Stage Name</th>
                <th class="col-subheader">Definition</th>
                <th class="col-comments" col="">Activities</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th>Suspect</th>
                <td>A person who has provided information (name, email, phone, company, etc) to company.</td>
                <td>
                    - Nurture via emails and automated communication channels <br>
                    - Continue to update profile as additional information is learned <br>
                    - Score and grade profile as updates and activity are recorded <br>
                </td>
            </tr>
            <tr>
                <th>MCL</th>
                <td>A person, who based on their company, title, or information provided, would be a potential customer.</td>
                <td>
                    - Nurture via communication channels including email <br>
                    - Sales Development Rep (SDR) prospects via telephone calls and personalized emails to understand need
                </td>
            </tr>
            <tr>
                <th>MQL</th>
                <td>A person, who through activity or indicated interest, warrants a prompt call from Sales/ SDR resource.</td>
                <td>
                    - SDR reaches out promptly when trigger is hit to move MCL to MQL <br>
                    - SDR attempts to qualify lead by understanding BANT Criteria (Budget, Authority, Need, Time) <br>
                    - SDR gages interest for an appointment with sales
                </td>
            </tr>
            <tr>
                <th>SAL </th>
                <td>A customer who has met basic qualification criteria and agreed to a meeting with sales to explore potential solutions in more depth.</td>
                <td>
                    - Sales rep, lead, and SDR participate in call to understand needs and opportunity <br>
                    - Sales Rep confirms that Lead meets opportunity criteria, or rejects in SFDC with reason code
                </td>
            </tr>
            <tr>
                <th>SQL</th>
                <td>A person who has been deemed by sales as worthy of their time in a sales campaign, and an opportunity in SFDC.</td>
                <td>
                    - Sales Rep converts lead to opportunity and pursues opportunity in SFDC <br>
                    - Sales Rep continues to work opportunity and execute against opportunity management process until lead is closed
                </td>
            </tr>
        </tbody>
    </table>
</div>
